import type { TypeSortDirection } from './api'

export interface CursorPagination {
  first?: string
  prev?: string
  cursor?: string
  next?: string
  last?: string
}

export interface CursorPaginationParams {
  search?: string
  limit?: number
  cursor?: string
  prev?: string
  sortBy?: string
  sortDirection?: TypeSortDirection
  [key: string]: string | number | boolean | null | undefined
}

export interface CursorPaginatedResponse<T> {
  data: T[]
  pageInfo: CursorPagination
}

export interface HookParams<T1, T2 = undefined> {
  params: T1
  keyFilter?: T2
  enabled?: boolean
}

export enum ViewMode {
  TABS = 'tabs',
  LIST = 'list',
}

export type TypeViewMode = 'tabs' | 'list'
